import { getAuth, onAuthStateChanged } from "@firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { useEffect, useState } from "react";
import app from "../firebase";

export type AuthUserInfo = {
  admin: boolean;
  displayName: string;
  email: string;
  uid: string;
};

export function useAuthUser(): [ AuthUserInfo | undefined, boolean ] {
  const [ user, setUser ] = useState<AuthUserInfo>();
  const [ loading, setLoading ] = useState(true);

  useEffect(() => {
    onAuthStateChanged(getAuth(app), (user) => {
      if (!user) { setUser(undefined); setLoading(false); }
      else user.getIdTokenResult().then(({ claims }) => {
        setUser({
          admin: (claims as any)[ 'admin' ],
          displayName: user.displayName!,
          email: user.email!,
          uid: user.uid
        });
      }).catch((err) => {
        console.error(err);
        setUser(undefined);
      }).finally(() => setLoading(false));
    });
  }, []);

  return [ user, loading ];
}

export function useAdminList(): AuthUserInfo[] {
  const [ admins, setAdmins ] = useState<AuthUserInfo[]>([]);

  useEffect(() => {
    (httpsCallable(getFunctions(app), 'getUserAccountList')()).then(({ data }) => {
      setAdmins((data as any).list as AuthUserInfo[]);
    }).catch((err) => {
      console.error(err);
    });
  }, []);

  return admins;
}

export async function addAdminUser(email: string, password: string, name: string) {
  return ((await httpsCallable(getFunctions(app), 'addAdminUser')({
    email: email, password: password, name: name
  })).data as any).uid as string;
}

export async function makeUserAdmin(uid: string) {
  await httpsCallable(getFunctions(app), 'makeUserAdmin')({ uid: uid });
}

export async function deleteUser(uid: string) {
  await httpsCallable(getFunctions(app), 'deleteUser')({ uid: uid });
}
